import { CvaListBadgeProps } from '../../types';
import styles from '../../CustomerValueAgreements.module.scss';
import { CatHeading } from '@blocks-react/components/Heading';

export const CVABadge = ({ children, classname }: CvaListBadgeProps) => {
  return (
    <div className={`${classname} ${styles['cva-modal-wrapper--badge']}`}>
      <CatHeading variant="label-sm" color="knockout">
        {children}
      </CatHeading>
    </div>
  );
};
